import {BaseModal, ModalFooter, ModalHeader} from "../BaseModal";
import React, {useEffect, useRef, useState} from "react";
import styled from 'styled-components';
import {Button} from "../../components/Button";
import {API} from "../../api";
import {isMobileDevice} from "../../hooks/mobile/isMobile";
import {localStorageManager} from "../../utils/localStorageManager";
import jsqr from 'jsqr';

const SContent =  styled.div`
    display: flex;
    flex-direction: column;
    
    label {
        margin-bottom: 10px;
    }
`;

const api = new API();
let interval = null;

export function AuthYmModal({isOpen, setOpen, isMobile=isMobileDevice()}) {
    const [authData, setAuthData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [qrContent, setQrContent] = useState(null);

    const checkAuth = (auth) => {
        if (!auth) return;
        api.authYm(auth.csrf_token, auth.track_id).then((resp) => {
            if (resp.success) {
                setOpen(false);
                localStorageManager.set("auth_flow", {});
                window.location.reload();
            }
        })
    };

    const scanImage = (img) => {
        console.log("scan img");
        setIsLoading(true);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Сохраняем оригинальные размеры
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        //setImgSize({ width, height });

        // Устанавливаем размеры canvas
        canvas.width = width;
        canvas.height = height;

        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);


        // Рисуем изображение на canvas
        ctx.drawImage(img, 0, 0);
        try {
            // Получаем данные изображения
            const imageData = ctx.getImageData(0, 0, width, height);

            // Сканируем QR-код
            const qrCode = jsqr(imageData.data, imageData.width, imageData.height);
            console.log("qr code cont", qrCode, imageData.data);
            if (qrCode) {
                setQrContent(qrCode.data);
            } else {

            }
        } catch (error) {
            console.error('Ошибка сканирования:', error);

        } finally {
            setIsLoading(false);
            canvas.remove();
        }
    };


    useEffect(() => {
        console.log(isOpen);
        if (isOpen) {
            const auth_flow = localStorageManager.get("auth_flow");
            const ct = new Date();
            if (auth_flow?.platform === "ym" && (ct - (new Date(auth_flow.date)) < 15*60*1000)) {
                setAuthData(auth_flow.data);
                interval = setInterval(() => {
                    checkAuth(auth_flow.data);
                }, 2500);
            } else {
                api.getYmQr().then((resp) => {
                    localStorageManager.set("auth_flow", {
                        platform: "ym",
                        data: resp,
                        date: new Date(),
                    });
                    setAuthData(resp);
                    interval = setInterval(() => {
                        checkAuth(resp);
                    }, 2500);
                })
            }


        } else {
            if (interval) {
                clearInterval(interval);
                interval = null;
                setAuthData(null);
            }
        }
    }, [isOpen]);

    const goLink = () => {
        window.location.href = qrContent;
    };

    return <BaseModal isOpen={isOpen} setOpen={setOpen}>
        <ModalHeader><span>Авторизация в Яндекс.Музыке</span></ModalHeader>
        <div>
            <SContent>
                {authData && <img src={authData.qr_code} style={{filter: 'invert(1)'}} onLoad={(e) => scanImage(e.target)}/>}
                <span style={{color: 'gray', marginTop:"15px"}}>Отсканируйте Qr код камерой приложения Яндекс.Старт</span>
                <span style={{color: 'gray', margin:"15px 0px 15px 0px", width: "100%", textAlign: "center"}}>или</span>
                <Button isLoading={isLoading} disabled={!qrContent} isRich={false} isPrimary={false} responsive={true} isMobile={isMobile} size="s" onClick={goLink}>Перейти по ссылке</Button>
            </SContent>
        </div>
        <ModalFooter>
            <Button size="s" responsive={isMobile} isRich={false} isPrimary={false} onClick={() => {
                setOpen(false);
                localStorageManager.set("auth_flow", {});
            }}>Отмена</Button>
        </ModalFooter>

    </BaseModal>
}
